// Bono a la cuenta de las promos de venta: su forma y cómo se dice.
// Puro, sin React.
import { formatMXN } from '@/shared/lib/format/money';

/** Bono Wallet de una promo de venta del equipo. */
export interface SaleBonus {
    promotionId: string;
    name: string;
    amountCents: number | null;
    /** «toda la tienda», «este equipo»…; `null` si no se sabe y entonces no se dice. */
    reachLabel: string | null;
}

/** «Bono $200 a tu cuenta Fiado», o sin monto si la promo no lo dice. */
export function accountBonusText(amountCents: number | null): string {
    if (amountCents === null) return 'Bono a tu cuenta Fiado';
    const pesos =
        amountCents % 100 === 0
            ? formatMXN(amountCents / 100).replace(/\.00$/, '')
            : formatMXN(amountCents / 100);
    return `Bono ${pesos} a tu cuenta Fiado`;
}
